<template lang="pug">
  .event-group
    .person-card.event-group__person-card
      .person-card__avatar.avatar.loading(ref="avatar")
        img.avatar__img(:src="avatarChecker(this.person.img)" :alt="person.name")
      .person-card__info
        .person-card__name {{person.name}}
        Rating.person-card__rating(
          v-if="person.rating"
          :value="person.rating || null"
        )
        .person-card__price {{priceToString(person.price)}}
    .event-group__list
      Event(v-for="event in events"
        :key="event.id"
        :event="event"
      )

</template>

<script>
import Rating from '@/components/Rating'
import Event from '@/components/EventGrid/Event'
import priceToString from '@/mixins/price-to-string'
import avatarChecker from '@/mixins/avatar-checker'
import imageOnload from '@/mixins/image-onload'


export default {
  name: 'Group',
  components: {Rating, Event},
  mixins: [priceToString, avatarChecker, imageOnload],
  props: {
    person: {
      type: Object,
      required: true
    },
    events: {
      type: Array,
      required: true
    },
  },
  mounted() {
    this.imageOnload({
      container: this.$refs?.avatar,
      className: 'loading'
    });
  }
}
</script>
